import { env } from '@mntn-dev/env'

export { env }
